import { createActions } from "redux-actions"

export const { liftersView } = createActions({
  LIFTERS_VIEW: {
    SET_NEW_LEAD: data => ({ data }),

    SET_FORM_STEPS: (newState, options) => ({ newState, options }),
  },
})
